/**
* DevExpress HTML/JS Reporting (viewer\parameters\parametersPanelStandalone.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { PreviewElements } from '../constants';
import { ParametersPanelModelBase } from './parametersPanelModelBase';
export class ParametersPanelStandalone extends ParametersPanelModelBase {
    constructor() {
        super(...arguments);
        this.showButtons = false;
        this._showHeader = false;
    }
    getDesignerParts() {
        return [
            { id: PreviewElements.ParametersPanel, templateName: PreviewElements.ParametersPanel, model: this.tabInfo, viewModel: this.tabInfo.getViewModel() }
        ];
    }
    initialize(originalParametersInfo) {
        super.initialize(originalParametersInfo);
        if (originalParametersInfo) {
            this.tabInfo.visible = true;
            this.tabInfo.active = true;
        }
    }
}
